"use client";

import React from "react";
import { ArrowRight } from "lucide-react";

/**
 * WebsiteForTradespeople — Section 8: Final CTA
 * Drop-in für: src/pages/WebsiteForTradespeople/sections/BeginYourExperience.tsx
 */

export default function BeginYourExperience() {
  return <section className="dark text-white relative w-full py-24 lg:py-32 overflow-hidden" style={{
    backgroundColor: "hsl(16,88%,54%)"
  }}>
      <div className="absolute inset-0 bg-gradient-to-br from-primary to-orange-600 shadow-[inset_0_0_60px_rgba(0,0,0,0.1)] z-0" />
      <div className="absolute inset-0 bg-white/5 z-0 pointer-events-none" />

      <div className="relative z-10 container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white drop-shadow-md leading-tight">
            Ihre nächsten Aufträge warten online
          </h2>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-medium leading-relaxed">
            Erstellen Sie jetzt Ihre Handwerker-Website — in Minuten, nicht
            Wochen. Kostenlos starten, jederzeit upgraden.
          </p>
          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="https://dashboard.pagemaker24.ch/sign-up" className="group inline-flex items-center justify-center gap-2 bg-white rounded-lg px-10 py-4 text-lg font-bold shadow-2xl transition-all duration-300 hover:bg-white/95 hover:scale-105" style={{
            color: "hsl(16,88%,54%)"
          }}>
              Kostenlos starten
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <p className="text-sm text-white/80">
              3 Tage gratis · Keine Kreditkarte
            </p>
          </div>
        </div>
      </div>
    </section>;
}